import Vue from 'vue';
import App from './app.vue';
import router from './router';
import store from './store';
import query from './constants/query';
import internationalStore from './store/international';
import './api';
import './plugins/axios';
import './plugins/countly';
import './plugins/sweet';
import './plugins/element';
import '@/styles/index.scss';
import '@/components';

Vue.config.productionTip = false;

store.registerModule('international', internationalStore);

store.dispatch('international/queryDomains').then(() => {
  store.dispatch('initLang').then((i18n) => {
    router.beforeEach((to, from, next) => {
      if (
          to.matched.some(record => record.meta.requiresAuth)
          && !(to.query.appKey || query.appKey)
      ) {
          next({
              name: '401'
          });
          return;
      }
      next();
    });
    new Vue({
      router,
      store,
      i18n,
      render: h => h(App)
    }).$mount('#app');
  });
});
